import { Button } from 'components/Form/Button/Button';
import { BasePopup } from 'components/Display/BasePopup/BasePopup';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type ReplaceConfirmationModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};
export const ReplaceConfirmationModal: FC<ReplaceConfirmationModalProps> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <BasePopup open={open} setOpen={onCancel}>
      <BasePopup.Body>
        <h1 className="text-lg font-semibold text-gray-900">
          {t('webedi:uploaded_file_alert.confirmationModal.title')}
        </h1>
        <p className="mt-2 text-sm text-gray-500">{t('webedi:uploaded_file_alert.confirmationModal.description')}</p>
        <div className="mt-4 flex items-center justify-end gap-2">
          <Button variant="secondary" onClick={onCancel} analyticsId="cancel-replace-confirmation">
            {t('common:cancel')}
          </Button>
          <Button variant="primary" onClick={onConfirm} analyticsId="confirm-replace-confirmation">
            {t('webedi:uploaded_file_alert.confirmationModal.confirm')}
          </Button>
        </div>
      </BasePopup.Body>
    </BasePopup>
  );
};
